import {locationContainer, RenderingServices} from '@wallaby-ui/core';

export default function baseTimelineAnnotationsStatefullFormatterParams(
  params,
  services: RenderingServices = {}
) {
  const {store} = services;
  const {queryParameters} = params;

  const ownQueryParameters = store
    ? store.getState()[locationContainer.LOCATION_REDUCER_STATE_ID].parameters
    : queryParameters;

  return {...params, ownQueryParameters};
}
